import React, { useEffect, useRef } from 'react';
import gsap from 'gsap';

interface FloatingOrbProps {
  color?: string;
  size?: number;
  duration?: number;
  delay?: number;
  intensity?: number;
}

export const FloatingOrb: React.FC<FloatingOrbProps> = ({
  color = 'rgba(233, 30, 140, 0.2)',
  size = 400,
  duration = 8,
  delay = 0,
  intensity = 80,
}) => {
  const orbRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!orbRef.current) return;

    // Create a floating animation timeline
    const tl = gsap.timeline({ repeat: -1 });

    tl.to(
      orbRef.current,
      {
        x: intensity,
        y: intensity * 0.7,
        duration: duration,
        ease: 'sine.inOut',
      },
      0
    )
      .to(
        orbRef.current,
        {
          x: -intensity * 0.5,
          y: -intensity * 0.5,
          duration: duration * 0.6,
          ease: 'sine.inOut',
        },
        duration
      )
      .to(
        orbRef.current,
        {
          x: intensity * 0.3,
          y: intensity,
          duration: duration * 0.7,
          ease: 'sine.inOut',
        },
        duration * 1.6
      )
      .to(
        orbRef.current,
        {
          x: 0,
          y: 0,
          duration: duration * 0.7,
          ease: 'sine.inOut',
        },
        duration * 2.3
      );

    return () => {
      tl.kill();
    };
  }, [duration, intensity]);

  return (
    <div
      ref={orbRef}
      style={{
        position: 'absolute',
        width: `${size}px`,
        height: `${size}px`,
        background: `radial-gradient(circle, ${color} 0%, transparent 70%)`,
        borderRadius: '50%',
        filter: 'blur(40px)',
        pointerEvents: 'none',
        zIndex: 0,
      }}
    />
  );
};
